import Vue from 'vue'
import Vuex from 'vuex'

import locales from './locales'
import calc from './calc'
import stickers from './stickers'
import stickersUploader from './stickersUploader'
import clients from './clients'
import account from './account'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        locales,
        calc,
        stickers,
        stickersUploader,
        clients,
        account,
    }
})
